// requiredFields — the per-event-type map of required form fields.
//
// Extracted VERBATIM from `components/AddEventForm.js` (module-level
// `REQUIRED_FIELDS`) as part of the behavior-preserving refactor (issue #240).
// This map is part of AddEventForm's PUBLIC contract: the source re-exports it
// (`export { REQUIRED_FIELDS }`) and the 13.1 contract test asserts the named
// export `REQUIRED_FIELDS` with these exact per-type field lists. The slimmed
// container (task 13.7) MUST re-export this same object from this module path so
// existing `import { REQUIRED_FIELDS } from '.../AddEventForm'` keeps working.
//
// Every per-type field list (and its ORDER) is copied exactly from the source;
// the order is observable to callers that iterate the list (validation, the
// parity test's `fillAllRequired`).
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * The required fields for each supported event type.
 *
 * @type {{ flight: string[], hotel: string[], car: string[], dining: string[] }}
 */
export const REQUIRED_FIELDS = {
  flight: ['airline', 'flightNumber', 'departureAirport', 'arrivalAirport', 'departureDate', 'departureTime', 'arrivalDate', 'arrivalTime'],
  hotel: ['name', 'address', 'checkInDate', 'checkOutDate'],
  car: ['company', 'pickupLocation', 'returnLocation', 'pickupDate', 'returnDate'],
  dining: ['name', 'address', 'reservationDate', 'reservationTime'],
};

export default REQUIRED_FIELDS;
